import {IRootState, RootState} from '../root-state.store'
import {IAgencyManagementService, AgencyManagementService} from '../../services'

export interface IAgencyManagementState extends IRootState<IAgencyManagementService> {
  characterProblems?: { level_1: any[], level_2: any[] };
  characterProblem?: any;
  characterProblemToEdit?: any;
  attachmentTypes?: any[];
  attachmentType?: any;
  attachmentTypeToEdit?: any;
  attribute?: any;
  attributeToEdit?: any;
  attributeTypes?: any[];
}

export class AgencyManagementState extends RootState implements IAgencyManagementState {
  characterProblems?: { level_1: any[], level_2: any[] };
  characterProblem?: any;
  characterProblemToEdit?: any;
  attachmentTypes?: any[];
  attachmentType?: any;
  attachmentTypeToEdit?: any;
  attribute?: any;
  attributeToEdit?: any;
  attributeTypes?: any[];
  constructor () {
    super({})
    this.service = new AgencyManagementService
    this.characterProblems = { level_1: [], level_2: [] }
    this.characterProblem = null
    this.characterProblemToEdit = {
      level: null,
      name: null
    }
    this.attachmentTypes = []
    this.attachmentType = null
    this.attachmentTypeToEdit = {
      level: null,
      name: null
    }
    this.attribute = null
    this.attributeToEdit = {
      name: null,
      unit: null
    }
    this.attributeTypes = []
  }
}



// WEBPACK FOOTER //
// ./src/store/agency-management/am-state.store.ts